import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "ui";

import { useAppMetadata } from "src/contexts/AppMetadataContext";

export function UpdateAvailableDialog() {
  const { t } = useTranslation();
  const metadata = useAppMetadata();
  const { isUpdateAvailable, currentVersion, latestVersion, dismissUpdate } =
    metadata.versionCheck;

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isUpdateAvailable) {
      setOpen(true);
    }
  }, [isUpdateAvailable]);

  function handleReload() {
    window.location.reload();
  }

  function handleDismiss() {
    dismissUpdate();
    setOpen(false);
  }

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("updateAvailable.title")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("updateAvailable.description")}
            <div className="mt-2 text-xs text-muted-foreground">
              {t("updateAvailable.versionInfo", {
                currentVersion: currentVersion,
                latestVersion: latestVersion,
              })}
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={handleDismiss}>
            {t("updateAvailable.later")}
          </AlertDialogCancel>
          <AlertDialogAction onClick={handleReload}>
            {t("updateAvailable.reloadNow")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
